module.exports = __webpack_public_path__ + "img/pad_icon_1.f905170c.png";